import {Chip} from '@mui/material';
import React, {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import useInPatient from '../../hooks/useInPatient';
import '../../styles/Components/InPatientSchedule.scss';
import {formatDate, formatTime} from '../../utils/dateTime';
import Filters from './Filters';
import InPatientTable from './InPatientTable';
import Header from './PageHeader';

const View = ({loaderchange, popupalert, popuptext}) => {
  const [filters, setFilters] = useState({search: ''});
  const [pagination, setPagination] = useState({pageIndex: 1, pageSize: 10});

  const sideactive = useSelector(state => state.counter.sidebarnav);

  const {procedures, hospitals, tableData, dataCount} = useInPatient(filters, pagination, loaderchange, popupalert, popuptext);

  const columns = useMemo(
    () => [
      {Header: 'Patient Name', accessor: 'patient'},
      {
        Header: 'Procedure',
        accessor: 'procedure',
        Cell: ({value}) => {
          const procedureName = procedures.find(p => p.name === value)?.name || 'Unknown';
          return procedureName;
        }
      },
      {
        Header: 'Hospital',
        accessor: 'hospital',
        Cell: ({value}) => {
          const hospitalName = hospitals.find(h => h.name === value)?.name || 'Unknown';
          return hospitalName;
        }
      },
      {
        Header: 'Date',
        accessor: 'admission_date',
        Cell: ({value}) => formatDate(value)
      },
      {
        Header: 'Time',
        accessor: 'time',
        Cell: ({row}) => formatTime(row.original.admission_date)
      },
      {Header: 'Paid In', accessor: 'payment_at', Cell: ({value}) => value || 'N/A'},
      {Header: 'Amount', accessor: 'amount', Cell: ({value}) => value || 'N/A'},
      // {Header: 'Status', accessor: 'status'}
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({value}) => {
          const getStatusColor = status => {
            switch (status) {
              case 'Pending':
                return 'warning';
              case 'Completed':
                return 'success';
              case 'Cancelled':
                return 'error';
              default:
                return 'default';
            }
          };

          if (value === 'cancel') {
            value = 'Cancelled';
          } else if (value === 'complete') {
            value = 'Completed';
          } else if (value === 'pending') {
            value = 'Pending';
          }
          return (
            <Chip
              label={value}
              color={getStatusColor(value)}
              // variant="outlined"
              size='small'
              sx={{
                height: '20px', // Reduce overall height
                padding: '0 6px', // Adjust padding
                '& .MuiChip-label': {
                  fontSize: '0.75rem', // Reduce text size
                  padding: '0 4px' // Adjust inner padding
                }
              }}
            />
          );
        }
      }
    ],
    [procedures, hospitals]
  );

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      {/* <h4 style={{marginBottom: '1rem'}}>Inpatient Schedule View</h4> */}
      <Header title='View Schedule' type='view' tableData={tableData} />
      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <Filters filters={filters} setFilters={setFilters} setPagination={setPagination} pageType='view' />
                  <InPatientTable data={tableData} columns={columns} pagination={pagination} setPagination={setPagination} datacount={dataCount} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
